<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none mr-auto" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="header-user" v-if="loggedInUser">
      <span>{{loggedInUser}}</span>
      <button type="button" class="btn btn-primary btn-sm" @click="logOut()">Log Out</button>
    </div>
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="footerToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
  </header>
</template>
<script>
export default {
  name: 'header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    footerToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('footer-hidden')
    },
    logOut () {
      this.$store.commit('logOut')
    }
  },
  computed: {
    loggedInUser: function () {
      return (this.$store.state.currentUser) ? this.$store.state.currentUser.email : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue